export default __webpack_public_path__ + "static/media/rounds.6e5131e5.png";